import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import SponsorTree from './sponsor/SponsorTree';
import BinaryTree from './binaryTree/BinaryTree';
import NetworkList from './network/NetworkList';

const SECTION = {
  SPONSOR: 'sponsor',
  BINARY: 'binary',
  NETWORK: 'network',
};

function TeamStructure({ t, directSellingSettings }) {
  const [section, setSection] = useState(SECTION.SPONSOR);
  const { binaryIntegration } = directSellingSettings;

  const handleChangeSection = useCallback(
    sectionToChange => setSection(sectionToChange),
    [setSection],
  );
  return (
    <Title title={t('my.network')}>
      <ContentContainer>
        <SubHeader title={t('my.network')} />
        <TopicBanner />
        <div className="m-content">
          <div className="full-page-container-with-subheader">
            <div className="row">
              <div className="col-lg-12">
                <div className="m-portlet m-portlet--mobile team-structure-page">
                  <div className="row team-structure-filters">
                    <div className="col-lg-7 filter">
                      <button
                        type="button"
                        onClick={() => handleChangeSection(SECTION.SPONSOR)}
                        className={`section-button ${
                          section === SECTION.SPONSOR && 'section-button-active'
                        }`}
                      >
                        {t('team.structure.sponsor.tree')}
                      </button>
                      {binaryIntegration && (
                        <button
                          type="button"
                          onClick={() => handleChangeSection(SECTION.BINARY)}
                          className={`section-button ${
                            section === SECTION.BINARY &&
                            'section-button-active'
                          }`}
                        >
                          {t('team.structure.binary.tree')}
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() => handleChangeSection(SECTION.NETWORK)}
                        className={`section-button ${
                          section === SECTION.NETWORK && 'section-button-active'
                        }`}
                      >
                        {t('users.network.structure')}
                      </button>
                    </div>
                  </div>
                  {section === SECTION.SPONSOR && <SponsorTree />}
                  {section === SECTION.BINARY && <BinaryTree />}
                  {section === SECTION.NETWORK && <NetworkList />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

TeamStructure.propTypes = {
  t: PropTypes.func.isRequired,
  directSellingSettings: PropTypes.shape({
    VAIntegration: PropTypes.bool.isRequired,
    salesIntegration: PropTypes.bool.isRequired,
    binaryIntegration: PropTypes.bool.isRequired,
  }).isRequired,
};

export default translate(TeamStructure);
